import { RequestService } from "services/request.service";

export class RetrieveUserApi extends RequestService {
	public retrieveUserApi = async () =>
		await this.request("auth/get-self", "GET", {});
}
